import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SaleOrderItemsDTO } from '..';


export class SaleOrderItemsDetailsResponseModel extends GlobalResponseObject {
    data?: SaleOrderItemsDTO[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /SaleOrderItemsDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SaleOrderItemsDTO[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 